<template>
  <div class="page-bg">
    <section class="login-page-container">
      <div class="login-container">
        <div class="system-title">
          <img src="/logo.png" class="system-logo" />
          <span class="system-name">项目文档管理系统</span>
        </div>
        <div v-if="showPortal==false" class="login-form">
          <a-input v-model="userName" type="text" size="large" placeholder="请输入账号" class="login-input" >
            <a-icon slot="prefix" type="user" />
          </a-input>
          <a-input-password v-model="password" size="large" placeholder="请输入密码" class="login-input" >
            <a-icon slot="prefix" type="key" />
          </a-input-password>
          <div class="input-comp">
            <a-input
                v-model="verifyCode"
                placeholder="请输入验证码"
                :max-length="4"
                size="large"
                class="code-input"
            >
              <a-icon slot="prefix" type="safety-certificate" />
            </a-input>
            <img
                :src="captchaImgUrl"
                alt="验证码"
                class="captcha-img"
                @click="refreshCaptcha"
            />
          </div>
          <a-button
              type="primary"
              size="large"
              @click="handleSubmit"
              :loading="loginLoading"
              block
          >
            登 录
          </a-button>
        </div>

        <p v-if="showPortal==false" class="notice-msg">本网站暂不提供账号注册，如有需要请联系公司：0510-82707686</p>

        <div v-if="showPortal" class="portal-container">
          <span class="choose-system field-label optional-field">请选择子系统</span>
        </div>
        <div v-if="showPortal" class="portal-container">
          <div class="portal-entry" @click="enterSystem">
            <img src="../assets/icon-central.png" class="entry-icon">
            <div class="entry-title">集中式光伏</div>
          </div>
          <div class="portal-entry" @click="enterSystem">
            <img src="../assets/icon-distribute.png" class="entry-icon">
            <div class="entry-title">分布式光伏</div>
          </div>
          <div class="portal-entry" @click="enterSystem">
            <img src="../assets/icon-house.png" class="entry-icon">
            <div class="entry-title">户用光伏</div>
          </div>
        </div>
        <div v-if="showPortal" class="portal-container">
          <div class="portal-entry" @click="showNotAvaliable">
            <img src="../assets/icon-wind.png" class="entry-icon">
            <div class="entry-title">风力发电</div>
          </div>
          <div class="portal-entry" @click="showNotAvaliable">
            <img src="../assets/icon-storage.png" class="entry-icon">
            <div class="entry-title">储能</div>
          </div>
        </div>
      </div>

      <div class="footer">
        迪坤新能源（江苏）有限公司 版权所有 @2025 | 沪ICP备2025117282号
      </div>
    </section>

    <a-modal
        :visible="changePwdVisible"
        title="设置新密码"
        okText="确定"
        cancelText="取消"
        @ok="startChangePwd"
        @cancel="changePwdVisible = false"
    >
      <div class="input-container">
        <span class="input-label">新的密码</span><a-input v-model="newPassword" type="password" placeholder="请输入新密码" class="val-input" />
      </div>
      <div class="input-container">
        <span class="input-label">重复新密码</span><a-input v-model="confirmPassword" type="password" placeholder="请再次输入新密码" class="val-input" />
      </div>
    </a-modal>
  </div>
</template>
<script>
import { baseURL } from "@/services/HttpService";
import { login } from "@/services/LoginService";
import { setPwd } from "@/services/UserService";
import {loadTaskCounts} from "@/services/DashboardService";

export default {
  data() {
    return {
      userName: "",
      password: "",
      verifyCode: "",
      captchaImgUrl: `${baseURL}/captchaImg?tm=${new Date().getTime()}`,
      errMsg: "",
      loginLoading: false,
      url: process.env.VUE_APP_API_HOST,
      changePwdVisible: false,
      newPassword: "",
      confirmPassword: "",
      landingPageRouteName: "",
      showPortal: false
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "normal_login" });
  },
  methods: {
    startChangePwd(){
      let validationMsg = this.validatePwdInput();
      if(validationMsg!==""){
        this.$message.error(validationMsg);
      } else {
        let params = {
          newPwd: this.newPassword,
          userId: ""
        }
        console.log('设置密码', params);
        setPwd(params).then(resp => {
          if(resp.data.code === "SUCCESS"){
            this.$message.success("密码设置成功");
            this.changePwdVisible = false;
            this.showPortal = true;
            //this.$router.push({ name: this.landingPageRouteName });
          } else {
            this.$message.error(resp.data.errorMsg);
          }
        });
      }
    },
    validatePwdInput(){
      if(!this.newPassword){
        return"请输入新密码";
      }
      if(!this.confirmPassword){
        return "请再次输入新密码";
      }
      if(this.newPassword !== this.confirmPassword){
        return "两次输入的新密码不一致";
      }
      return "";
    },
    // 刷新验证码
    refreshCaptcha: function () {
      this.captchaImgUrl = `${baseURL}/captchaImg?tm=${new Date().getTime()}`;
      this.verifyCode = "";
    },
    handleSubmit(e) {
      e.preventDefault();
      if (this.userName === "") {
        this.$message.warning('请输入用户名');
        return;
      }
      if (this.password === "") {
        this.$message.warning('请输入密码');
        return;
      }
      if (this.verifyCode === "") {
        this.$message.warning('请输入图片验证码');
        return;
      }
      this.loginLoading = true;
      const params = {
        userName: this.userName,
        password: this.password,
        captcha: this.verifyCode,
        terminalType: "web",
      };
      login(params)
        .then((resp) => {
          this.loginLoading = false;
          if (resp.data.code === "SUCCESS") {
            this.$message.success("登录成功");
            const tokenInfo = resp.data.data;
            localStorage.setItem("userId", tokenInfo.userId);
            localStorage.setItem("realName", tokenInfo.name);
            localStorage.setItem("menuList", JSON.stringify(tokenInfo.menuList));
            localStorage.setItem("accessToken", tokenInfo.token);
            localStorage.setItem("roleIds", JSON.stringify(tokenInfo.roleList));
            // 默认二级子左侧menus菜单openKeys
            let openKeys = [];
            tokenInfo.menuList.forEach(rootMenu => {
              if (rootMenu.subMenus) {
                rootMenu.subMenus.forEach(item => {
                  openKeys.push(item.menuId);
                });
              }
            });
            localStorage.setItem("openKeys", JSON.stringify(openKeys));
            this.$store.dispatch("setUserMenu", tokenInfo.menuList);

            let landingPageRouteName = "Welcome";
            if (tokenInfo.menuList && tokenInfo.menuList.length > 0) {
              let menu = tokenInfo.menuList[0];
              if (!menu.path && menu.subMenus.length > 0) {
                landingPageRouteName = menu.subMenus[0].path;
              } else {
                landingPageRouteName = menu.path;
              }
            }
            this.landingPageRouteName = landingPageRouteName
            // 使用初始密码登录，强制修改密码
            if(tokenInfo.useInitialPwd){
              this.changePwdVisible = true;
            } else {
              this.showPortal = true;
              this.refreshTaskCounts();
            }
          } else {
            this.errMsg = resp.data.errorMsg;
            this.refreshCaptcha();
          }
        })
        .catch(() => {
          this.loginLoading = false;
        });
    },
    refreshTaskCounts(){
      loadTaskCounts().then(response => {
        if (response.data.code === "FAILED") {
          console.log("服务端错误", response.data.errorMsg);
        } else {
          console.log('task counts:', response.data.data);
          this.$store.dispatch("updateTaskCounts", response.data.data);
        }
      });
    },
    onRegister() {
      this.$router.push({ name: "Register" });
    },
    showNotAvaliable() {
      this.$message.info("该账号暂无权限，如有需要请联系管理员");
    },
    enterSystem() {
      this.$router.push({ name: this.landingPageRouteName });
    }
  }
}
</script>
<style scoped lang="less">
.page-bg {
  height: 100vh;
  background-color: white;
}
.login-page-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: url(../assets/solar-login-bg.png) no-repeat center center;
  background-size: cover;
}
.login-container {
  flex-grow: 1;
}
.system-logo {
  width: 34px;
  height: 34px;
}
.notice-msg {
  margin-left: 24vw;
  margin-top: 40px;
  color: #999999;
  padding-left: 14px;
}
.system-title {
  width: 400px;
  margin-top: 160px;
  margin-bottom: 30px;
  margin-left: 24vw;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.system-name {
  color: rgba(0, 0, 0, 0.88);
  padding-left: 10px;
  font-weight: bold;
  font-size: 32px;
}
.system-introduction {
  text-align: center;
  margin-top: 12px;
  margin-bottom: 40px;
  color:  rgba(0, 0, 0, 0.65);
  font-size: 14px;
}
.login-form {
  width: 360px;
  margin-left: 25vw;
}
.login-input {
  border-radius: 10px;
  margin-bottom: 24px;
}
.input-comp {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  margin-bottom: 48px;
}
.code-input {
  width: 288px;
}
.captcha-img {
  height: 38px;
}
.action-box {
  text-align: right;
  margin-top: 10px;
}
.register-btn {
  padding-right: 0;
}
.footer {
  height: 50px;
  color:  rgba(0, 0, 0, 0.65);
  font-size: 14px;
  text-align: center;
}
.input-container{
  padding-top: 4px;
  padding-bottom: 4px;
}
.input-label {
  display: inline-block;
  width: 100px;
  margin-right: 10px;
}
.val-input {
  width: 200px;
}
.portal-container {
  display: flex;
  justify-content: flex-start;
  width: 40%;
  margin-left: 24vw;
  margin-bottom: 30px;
}
.choose-system {
  margin-left: 50px;
}
.portal-entry {
  display: flex;
  margin-left: 50px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #0543FF;
  border-radius: 20px;
  min-width: 120px;
  min-height: 120px;
  background-color: white;
  opacity: 0.7;
  cursor: pointer;
  box-shadow: 2px 2px 5px #888888;
}
.entry-icon {
  width: 40px;
}
.entry-title {
  margin-top: 10px;
  font-size: 16px;
  color: #0543FF;
}
</style>